const Cookies = () => {
    return (
        <div className="cookies">
            <h1>Cookies Policy</h1>
            
            <p>
                Some of the Internet pages use so-called cookies. Cookies do not cause any damage to your computer and do not contain viruses. Cookies are used to make our website more user-friendly, effective and secure. Cookies are small text files that are stored on your computer and saved by your browser. This cookie contains a characteristic string of characters that allows the browser to be uniquely identified when you return to the website.
                
            </p>
            <p>
                Some elements of our website require that the calling browser can be identified even after a page change. The following data is stored and transmitted in the cookies:
                
            </p>
                <ul>
                    	<li>language settings</li>
                    	<li>log-in-information</li>
                    	<li>frequency of page views</li>
                    	<li>use of website functions</li>
                </ul>
            
            <p>
                The data collected in this way will be pseudonymised by technical precautions. It is therefore no longer possible to assign the data to the calling user. The data are not stored together with other personal data of the users.
                
            </p>
            <p>
                The legal basis for the processing of personal data using cookies is Art. 6 para. 1 lit. f GDPR.
                
            </p>
            <p>
                Most of the cookies we use are so-called "session cookies". They will be automatically deleted at the end of your visit. Other cookies remain stored on your device until you delete them. These cookies enable us to recognize your browser the next time you visit our website.
                
            </p>
            <p>You can set your browser in such a way that you are informed about the setting of cookies and allow cookies only in individual cases, you can exclude the acceptance of cookies for certain cases or generally and you can activate the automatic deletion of cookies when closing the browser. When cookies are disabled, the functionality of this website may be limited.</p>


        </div>
    );
}

export default Cookies;